import { render, staticRenderFns } from "./CitiesChips.vue?vue&type=template&id=5cd0a948"
import script from "./CitiesChips.vue?vue&type=script&lang=js"
export * from "./CitiesChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports